import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { Lazy } from "lib/make-lazy"
import { hasDemand } from "lib/authorization/has-demand"

registerSystemAdminTab(
    "Memory",
    <Lazy importer={() => import("./memory-status.js")} extract="MemoryStatus" />,
    () => hasDemand("admin"),
    120
)
